import { combineReducers } from 'redux';
import * as AuthenticationReducers from './Authentication/reducers';
import * as OrderReducers from './Order/reducers';
import * as RewardReducers from './Reward/reducers';

export default combineReducers({ 
    ...AuthenticationReducers,
    ...OrderReducers,
    ...RewardReducers
})